import { contentfulImageUrl } from '@telialt/utils/src/Contentful/contentfulImageUrl';
import { withParams } from '@telialt/utils/src/helpers';

import { CONTENT_TYPE_TO_URL_SLUG_MAP } from '../../constants';
import { BlogArticleType } from '../../models/Content';
import { ArticleCardData } from './model';

export const transformArticleCard = (contentItem: BlogArticleType): ArticleCardData => {
    const { fields } = contentItem;

    return {
        id: contentItem.sys.id,
        category: fields.categories?.[0]?.fields.title,
        authors:
            fields.authors?.map((author) => {
                const authorData = author.fields;

                return {
                    title: authorData.title,
                    description: authorData.description,
                    image: contentfulImageUrl(authorData.image?.fields?.imageSm?.fields?.file?.url),
                };
            }) || [],
        title: fields.title,
        href: withParams(CONTENT_TYPE_TO_URL_SLUG_MAP.blogArticle, { slug: fields.slug }),
        effectiveDate: fields.effectiveDate,
        summary: fields.summary,
        bannerImage: fields.bannerImage
            ? {
                  image: contentfulImageUrl(fields.bannerImage.fields?.imageMd?.fields?.file?.url),
                  description: fields.bannerImage.fields?.altText,
                  width: fields.bannerImage.fields?.imageMd?.fields?.file?.details?.image?.width,
                  height: fields.bannerImage.fields?.imageMd?.fields?.file?.details?.image?.height,
              }
            : undefined,
        authorsImage: fields.authorsImage
            ? {
                  image: contentfulImageUrl(fields.authorsImage.fields?.file?.url),
                  description: fields.authorsImage.fields?.description,
              }
            : undefined,
    };
};
